<template>
  <div>
    <b-row>
      <b-col>
        <h2 class="mb-3">When do you travel ?</h2>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <v-date-picker
          mode='range'
          is-inline
          is-expanded
          :columns="$screens({ default: 1, lg: 2 })"
          title-position="left"

          v-model='dates'
          :min-date='min_date'
          :max-date='max_date'
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
// external dependencies
import moment from 'moment'

// custom component

// api call

export default {
  name: 'Order_ModalDate',
  props: ['start_date', 'end_date'],
  components: {
  },
  data () {
    return {
      dates: {
        start: new Date(moment(this.start_date, 'DD/MM/YYYY').format('l')),
        end: new Date(moment(this.end_date, 'DD/MM/YYYY').format('l'))
      },

      min_date: new Date(moment().startOf('day').format('l')), // min today
      max_date: new Date(moment().startOf('day').add(365, 'days').format('l')) // max 1 year from today
    }
  },
  watch: {
    dates: function (newDate) {
      this.$emit('setDate', newDate)
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Order/ModalDate/ModalDate.vue